import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowBackIos, ArrowForwardIos } from '@material-ui/icons';
import BotService from '../../../services/BotService/BotService';
import Selections from './selections/Selections';
import Category from './category/Category';
import Variant from './variant/Variant';
import Config from './config/Config';
import Alerts from './alerts/Alerts';
import Test from './test/Test';
import Deploy from './deploy/Deploy';
import './Variants.css';
/**
 * @Description This function returns Variants page.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
export function useQuery () {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}
function Variants () {
    const { t } = useTranslation();
    let query = useQuery();
    const label = 'CONTENT.VARIANTS.';
    const [state, setState] = useState({
        category: [],
        source_app: [],
        destination_app: [],
        variant: { first: [], second: [] },
        config: [],
        alerts: []
    });
    const [step, setStep] = useState(0);

    useEffect(() => {
        let oldState, oldStep;
        try {
            oldState = JSON.parse(localStorage.getItem('variant_state'));
            oldStep = JSON.parse(localStorage.getItem('variant_step'));
        } catch (e) { }
        if (window.location.pathname.includes('autom-store')) {
            if (oldState) {
                setState(oldState);
                if (oldStep) { setStep(oldStep); }
            }
        } else {
            fetchQuery();
        }
    }, []);

    const fetchQuery = async () => {
        let category = query.get('category')?.split(',');
        if (category) {
            let res = await BotService.getCategoryFilter();
            if (res?.status) {
                state.category = res.data.filter(i => category.includes(i.id));
            }
        }
        let source_app = query.get('src_app')?.split(',');
        if (source_app) {
            let res = await BotService.getApplicationFilter();
            if (res?.status) {
                state.source_app = res.data.filter(i => source_app.includes(i.id));
            }
        }
        let destination_app = query.get('dest_app')?.split(',');
        if (destination_app) {
            let res = await BotService.getApplicationFilter();
            if (res?.status) {
                state.destination_app = res.data.filter(i => destination_app.includes(i.id));
            }
        }
        let queryStep = query.get('step');
        setState({ ...state });
        if (queryStep) { setStep(parseInt(queryStep)); }
    };
    const handleClick = (index) => {
        localStorage.setItem('variant_step', JSON.stringify(index));
        setStep(index);
    };

    const prevClick = () => {
        if (step > 0) {
            localStorage.setItem('variant_step', JSON.stringify(step - 1));
            setStep(step - 1);
        }
    };

    const nextClick = () => {
        if (step < 7) {
            localStorage.setItem('variant_step', JSON.stringify(step + 1));
            setStep(step + 1);
        }
    };

    const checkProgressable = (index) => {
        const steps = ['category', 'source_app', 'destination_app', 'variant', 'config', 'alerts'];
        if (index === 6) {
            if (state.variant.first.length < 1) { return true; }
            for (const item of state.variant.first) {
                if (!item.test || item.test === 2) {
                    return true;
                }
            }
            return false;
        }
        else if (index === 5  || index === 4) {
            if (state.variant.first.length < 1) { return true; }
            for (const item of state.variant.first) {
                if (item.config) {
                    for (const iter of item.config) {
                        if (!iter.value || !/\S/.test(iter.value)) {
                            return true;
                        }
                    }
                }
            }
            return false;
        }
        else if (index === 3 && (state.variant.first.length > 0 || state.variant.second.length > 0)) { return false; }
        else if (state[steps[index]]?.length > 0) { return false; }
        else { return true; }
    };

    const steps = ['CATEGORY', 'SOURCE-APP', 'DEST-APP', 'VARIANTS', 'VARIANTS-CONFIG', 'ALERTS', 'TEST-RUN', 'DEPLOY'];
    return (
        <div className="variants">
            <div className="step0">
                <button className="vbutton vred">{t(label + 'NEW')}</button>
            </div>
            <div className="step0l vlinev"><div className="vline-v varrow-d"></div></div>
            <div className="step1">
                <button className={`vbutton${step === 0 ? ' vbutton-s' : ''}`}
                    onClick={() => handleClick(0)}>
                    {t(label + 'CATEGORY')} <span className="vstep-plus">+</span>
                </button>
                <Selections step="category" setStep={handleClick} state={state} setState={setState} />
            </div>
            <div className="step1l vlinev">
                <div className="vline-v varrow-d"></div>
            </div>
            <div className="step2">
                <button className={`vbutton${step === 1 ? ' vbutton-s' : ''}`}
                    onClick={() => handleClick(1)} disabled={checkProgressable(0)}>
                    {t(label + 'SOURCE-APP')} <span className="vstep-plus">+</span>
                </button>
                <Selections step="source_app" setStep={handleClick} state={state} setState={setState} />
            </div>
            <div className="step2l vlinev">
                <div className="vline-v varrow-d"></div>
            </div>
            <div className="step3">
                <button className={`vbutton${step === 2 ? ' vbutton-s' : ''}`}
                    onClick={() => handleClick(2)} disabled={checkProgressable(1)}>
                    {t(label + 'DEST-APP')} <span className="vstep-plus">+</span>
                </button>
                <Selections step="destination_app" setStep={handleClick} state={state} setState={setState} />
            </div>
            <div className="step3d vlinev">
            </div>
            <div className="step3l vlineh"><div className="vline-h varrow-r"></div></div>
            <div className="step4">
                <button className={`vbutton${step === 3 ? ' vbutton-s' : ''}`}
                    onClick={() => handleClick(3)} disabled={checkProgressable(2)}>
                    {t(label + 'VARIANTS')}
                </button>
            </div>
            <div className="step4d"></div>
            <div className="step4l vlineh"><div className="vline-h varrow-r"></div></div>
            <div className="step5 ">
                <button className={`vbutton${step === 4 ? ' vbutton-s' : ''}`}
                    onClick={() => handleClick(4)} disabled={checkProgressable(3)}>
                    {t(label + 'VARIANTS-CONFIG')}
                </button>
            </div>
            <div className="step5d"></div>
            <div className="step5l vlinev"><div className="vline-v varrow-u"></div></div>
            <div className="step6">
                <button className={`vbutton${step === 5 ? ' vbutton-s' : ''}`}
                    onClick={() => handleClick(5)} disabled={checkProgressable(4)}>
                    {t(label + 'ALERTS')}
                </button>
            </div>
            <div className="step6l vlinev"><div className="vline-v varrow-u"></div></div>
            <div className="step7">
                <button className={`vbutton${step === 6 ? ' vbutton-s' : ''}`}
                    onClick={() => handleClick(6)} disabled={checkProgressable(5)}>
                    {t(label + 'TEST-RUN')}
                </button>
            </div>
            <div className="step7l vlinev">
                <div className="vline-v varrow-u"></div>
            </div>
            <div className="step8">
                <button className={`vbutton vgreen${step === 7 ? ' vbutton-s' : ''}`}
                    onClick={() => handleClick(7)} disabled={checkProgressable(6)}>
                    {t(label + 'DEPLOY')}
                </button>
            </div>
            <div className="step8l vlineh"><div className="vline-h varrow-l vfullw"></div></div>
            <div className="vcenter">
                <div className="vmain">
                    <div className="vmain-header">{t(label + steps[step])}</div>
                    {(step === 0 || step === 1 || step === 2) && <Category step={step} state={state} setState={setState} />}
                    {step === 3 && <Variant state={state} setState={setState} />}
                    {step === 4 && <Config state={state} setState={setState} />}
                    {step === 5 && <Alerts state={state} setState={setState} />}
                    {step === 6 && <Test state={state} setState={setState} />}
                    {step === 7 && <Deploy state={state} />}
                    <button className="vstep-b vprev" onClick={prevClick} disabled={step===0}><ArrowForwardIos fontSize="small" /></button>
                    <button className="vstep-b vnext" onClick={nextClick} disabled={checkProgressable(step)}><ArrowBackIos fontSize="small" /></button>
                </div>
            </div>
        </div>
    );
}
export default Variants;